import Head from "next/head";
import CLMHero2 from "components/CLM/CLMHero2";
import EqualDivisionSection from "components/CLM/EqualDivisionSection";
import FAQ2 from "components/CLM/FAQ2";
import { useState } from "react";
import TestimonialSlider from "components/CLM/TestimonialSliderSection";
import { BASE_ASSETS_URL } from "@constants/constants";

const CLMHeroData = {
  // title: "Reporting",
  heading: "Review contracts in minutes, not hours",
  description: "Let AI do your work 70% faster with greater accuracy",
  image: `${BASE_ASSETS_URL}/v2/clm/clm/ai-verification-hero.gif`,
  btnText: "Review a contract for free",
  btnUrl: "/clm/request-demo",
};

const aiVerificationFaqData = [
  {
    question: "What is AI Verification?",
    answer:
      "AI Verification is BoloSign’s intelligent layer built to verify signer identities during the document signing process. It ensures that the person signing is genuine by using facial comparison, behavior analysis, and secure data validation—all within seconds.",
  },
  {
    question: "What can I do with AI Verification?",
    answer:
      "AI Verification allows you to:\n\n- Automatically detect mismatches between a signer's photo and ID\n- Flag potential identity issues before a document is signed\n- Apply specific verification checks based on document type\n- Share verification results securely with your internal teams\n- Maintain legal integrity and reduce fraudulent signing",
  },
  {
    question: "When can I use AI Verification?",
    answer:
      "You can use AI Verification every time a document is sent for signature. Whether it’s your own contract or one shared with a counterparty, the feature is ready to activate at the click of a button. It’s especially helpful for legal, HR, or financial teams that need reliable identity proof.",
  },
  {
    question: "How does AI Verification work?",
    answer:
      "AI Verification works as a built-in workflow in BoloSign:\n\n- Signer receives the verification prompt before accessing the document\n- They’re asked to take a live selfie or upload an ID\n- Our AI checks for facial match, liveness, and anomalies\n- If all checks are passed, the signing continues\n- Failed attempts are flagged and reported with reasoning\n\nNo extra software is needed—it works right inside the browser.",
  },
  {
    question: "What AI model does BoloSign use for verification?",
    answer:
      "BoloSign uses a combination of leading LLMs and computer vision models tailored for secure identity validation. These models are chosen dynamically to ensure the best result for the verification task, without relying solely on a single provider like OpenAI. All models are used within a compliant, secure cloud environment.",
  },
  {
    question: "How is data stored and handled in AI Verification?",
    answer:
      "We prioritize privacy and data protection. Verification data is encrypted in transit and at rest, processed securely, and stored in compliance with major privacy laws such as GDPR. We never share or repurpose user biometric data.",
  },
];

// const testimonials = [
//   {
//     companyLogo: "https://via.placeholder.com/100x30?text=Circularise",
//     quote:
//       "The metadata management at SpotDraft is really amazing... my team can access key terms any time, without needing me to provide that .",
//     avatar: "https://randomuser.me/api/portraits/women/44.jpg",
//     name: "Arzu Hasanova",
//     title: "Legal Counsel at Circularise",
//   },
//   {
//     companyLogo: "https://via.placeholder.com/100x30?text=Fintract",
//     quote:
//       "SpotDraft transformed how we handle contracts. It’s efficient, intuitive, and has become an essential part of our workflow.",
//     avatar: "https://randomuser.me/api/portraits/men/32.jpg",
//     name: "John Miller",
//     title: "Head of Legal at Fintract",
//   },
// ];

// function TestimonialSlider({ testimonials, currentIndex, setCurrentIndex }) {
//   const transition = { duration: 0.5, ease: "easeInOut" };

//   const variants = {
//     enter: { y: 20, opacity: 0 },
//     center: { y: 0, opacity: 1 },
//     exit: { y: 25, opacity: 0 },
//   };

//   return (
//     <div className="px-8  max-w-screen-xl xl:mx-auto">
//       <section className="bg-blue-50 rounded-3xl py-4 mx-4 md:mx-10 px-4 md:py-20 md:px-48 my-12 shadow-sm transition-all duration-400 max-w-screen-xl xl:mx-auto">
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={currentIndex}
//             initial="enter"
//             animate="center"
//             exit="exit"
//             variants={variants}
//             transition={transition}
//           >
//             {/* Logo */}
//             <div className="mb-4">
//               <Image
//                 src={`${BASE_ASSETS_URL}/v2/clm/clm//circularise.svg")}
//                 alt="Company Logo"
//                 width={200}
//                 height={200}
//               />
//             </div>

//             {/* Quote */}
//             <p className="text-2xl text-gray-900 mb-6">
//               “{testimonials[currentIndex].quote}”
//             </p>

//             {/* Avatar + Name */}
//             <div className="flex items-center justify-left gap-4">
//               <Image
//                 src={testimonials[currentIndex].avatar}
//                 alt={testimonials[currentIndex].name}
//                 width={50}
//                 height={50}
//                 className="rounded-lg object-cover"
//               />
//               <div className="text-sm">
//                 <p className="font-semibold text-gray-900">
//                   {testimonials[currentIndex].name}
//                 </p>
//                 <p className="text-gray-600">
//                   {testimonials[currentIndex].title}
//                 </p>
//               </div>
//             </div>
//           </motion.div>
//         </AnimatePresence>

//         {/* Arrows */}
//         {/* when the button is disabled it should be dull in color */}
//         {/* when the button is enabled it should be bright in color */}
//         <div className="flex justify-end mt-6 gap-4">
//           <button
//             onClick={() => setCurrentIndex((i) => i - 1)}
//             disabled={currentIndex === 0}
//           >
//             <ArrowLeftIcon
//               className={
//                 currentIndex === 0
//                   ? "w-6 h-6 text-blue-200"
//                   : "w-6 h-6 text-blue-600"
//               }
//             />
//           </button>
//           <button
//             onClick={() => setCurrentIndex((i) => i + 1)}
//             disabled={currentIndex === testimonials.length - 1}
//           >
//             <ArrowRightIcon
//               className={
//                 currentIndex === testimonials.length - 1
//                   ? "w-6 h-6 text-blue-200"
//                   : "w-6 h-6 text-blue-600"
//               }
//             />
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

const AIVerification = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <>
      <Head>
      <title>AI Verification | BoloSign CLM</title>
      <meta
        name="description"
        content="AI Verification is BoloSign’s intelligent layer built to verify signer identities during the document signing process. It ensures that the person signing is genuine by using facial comparison, behavior analysis, and secure data validation—all within seconds."
      />
      <meta
        name="keywords"
        content="AI Verification, Contract Management, eSignatures, Identity Verification, BoloSign CLM, Secure Signing, AI-powered Contracts"
      />
      <link rel="canonical" href="https://www.bolosign.com/clm/ai-verification/" />
    </Head>
      <CLMHero2 CLMHeroData={CLMHeroData} />
      <div className="text-center bg-cream py-24">
        <h2 className="text-4xl md:text-5xl mb-6">
          Smarter, faster & easier contract reviews
        </h2>
        <p className="text-xl lg:w-[70%] xl:w-[50%] mx-auto px-6 md:px-0">
          AI Verification lets you create and run contract review playbooks in
          seconds, using AI trained by top legal experts for unmatched accuracy
          and efficiency.
        </p>
      </div>

      {/* equal division section */}
      <EqualDivisionSection
        // title=""
        heading="Speed up contract reviews with AI-powered custom playbooks"
        description="Turn your legal expertise into contract review workflows. With simple inputs, you can build tailored playbooks to identify risks, track compliance, and streamline your review process in seconds."
        checks={[
          "Link each guideline to its source for clarity and context.",
          "Know exactly why a clause passes or fails compliance checks.",
          "Easily update and refine your playbooks as standards evolve.",
        ]}
        image={`${BASE_ASSETS_URL}/v2/clm/clm/ai-verification-agreement.gif`}
        bgColor=""
        imageRight={true}
      />

      <EqualDivisionSection
        // title=""
        heading="Improve your contracts with precise edits & Insights"
        description="Leverage insights shaped by the experience of hundreds of legal professionals to refine and strengthen your agreements."
        checks={[
          "Receive tailored language suggestions to reflect your intent in the contract.",
          "Add contextual comments to clarify changes for collaborators or reviewers.",
          "Edit contracts with visible track changes for transparency and review.",
        ]}
        image={`${BASE_ASSETS_URL}/v2/clm/clm/ai-verification-improve-contract.gif`}
        bgColor="bg-dark"
        imageRight={false}
      />

      <EqualDivisionSection
        // title=""
        heading="Instantly create review playbooks from your templates"
        description="Turn any contract template into a smart review playbook within minutes using AI."
        checks={[
          'Upload your template and hit "Generate with AI".',
          "Instantly receive a playbook with auto-drafted rules and review guidelines.",
          "Run any contract through your playbook with just a click.",
        ]}
        // image={`${BASE_ASSETS_URL}/v2/clm/clm//ai-verification-instantly.gif`}
        video={`${BASE_ASSETS_URL}/v2/clm/videos/ai-verification-instantly.mp4`}
        bgColor=""
        imageRight={true}
      />

      {/* <section className="bg-black py-24 text-white py-12 px-8">
        <div className="text-center bg-[#2a2a2a] p-12 rounded-2xl border border-2 border-white/20 max-w-screen-xl mx-auto">
          <p className="text-xl font-semibold mb-8">
            “Making updates to key contract clauses—like changing jurisdictions
            or adjusting rules—was surprisingly smooth. The interface was
            intuitive, and honestly, it stood out from the other AI tools I
            explored.”
          </p>
          <p className="text-lg">
            – Rachel Singh, Legal Associate, Horizon Health
          </p>
        </div>
      </section> */}

      <TestimonialSlider
      // testimonials={testimonials}
      // currentIndex={currentIndex}
      // setCurrentIndex={setCurrentIndex}
      />

      <EqualDivisionSection
        // title=""
        heading="Let your team handle the initial contract review"
        description="Empower cross-functional teams to perform the first-level contract checks by sharing easy-to-access contract guides. This helps spot common issues early, without needing to send every document to Legal right away."
        checks={[
          "Instantly share review guides via a link – no login required.",
          "Skip the need for Microsoft Word or heavy software.",
          "Access and review on both mobile and desktop with ease.",
        ]}
        // image={`${BASE_ASSETS_URL}/v2/clm/clm//ai-verification-new-msg.gif")}
        video={`${BASE_ASSETS_URL}/v2/clm/videos/ai-verification-new-msg.mp4`}
        bgColor=""
        imageRight={false}
      />

      {/* FAQ Section */}
      <section className="bg-cream text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ">
        <FAQ2
          faqData={aiVerificationFaqData}
          heading={"AI Verification FAQs"}
        />
      </section>
    </>
  );
};

export default AIVerification;
